module.exports = __webpack_public_path__ + "img/cta-mind-mob-nl.3fce0c1d.png";